import React from "react";

/*
 * Contexte pour surligner (entourer) les docks dont TOUTES les commandes sont Paris intramuros —
 * les tournées scooter — afin de les distinguer visuellement des autres types de véhicule sur
 * l'écran /dispatch. Valeur = booléen (surlignage actif ou non).
 */
export const DockHighlightContext = React.createContext(false);
